// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indi-login-page-left-side img {
    object-fit: fill;
    position: absolute;
    /* width: 50% !important; */
}

.container .card .indi-login-page-right-side {
    padding: 20px;
}

.indi-login-page-right-top-logo {
    height: 100px;
    padding-right: 20px;
}

.indi-login-page-right-top-logo img {
    height: 75px;
    width: 135px;
    float: right;
    position: relative;
}

.indi-login-page-right-top-logo p {
    font-size: 13px;
    font-weight: 600;
}

.indi-login-page-right-top-logo p a {
    margin-left: 3px;
}

.indi-login-form-headings {
    margin-top: 40px;
    color: #2f4694;
    font-weight: 600;
}

.indi-login-form-text-login {
    font-size: 25px;
}

.indi-login-form-text-desc {
    margin-top: 30px;
    font-weight: 600;
}

.indi-login-form-wrapper {
    /* background-color: lightgrey; */
    /* padding: 0 110px; */
    /* margin: 0 110px; */
    margin: 0 30%;
    /* border: 1px dotted lightgrey; */
}

.indi-login-form-input {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    box-shadow: inset 0 0 0 transparent;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    height: 38px;
    width: 100%;
    padding: 0 10px;
    font-size: 13px;
    border-radius: 3px;
    border-color: #80bdff;
}

.indi-login-form-input:focus {
    color: #495057;
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 2px rgb(13, 110, 253, 0.25);
}

.indi-login-form-input-wrapper {
    position: relative;
    margin-top: 20px;
    height: 60px;
}

.indi-login-form-input-wrapper p {
    margin-top: 4px;
    font-size: 12px;
    color: #ff4500;
    position: absolute;
    /* display: none; */
}

.indi-login-remember-reset {
    /* border: 1px dotted green; */
    /* height: 16px; */
    height: auto;
    position: relative;
    top: 12px;
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
    align-content: center;
    flex-direction: row;
}

.indi-login-remember-reset.indi-login-remember-reset-extra-info {
    position: static;
}

.indi-login-remember-checkbox.form-check-input {
    height: 16px;
    width: 16px;
    display: flex;
    cursor: pointer;
}

.indi-login-remember-label {
    margin-left: 4px;
    display: flex;
}

.indi-login-remember-reset>div {
    width: 50%;
    height: 100%;
}

.indi-login-form-btn-wrapper.m-0 {
    margin-top: 31px !important;
}

.indi-login-reset-wrapper {
    text-align: end;
    float: right;
    position: relative;
    width: 50%;
    right: 0;
}

.indi-login-reset-wrapper:hover {
    cursor: pointer;
    text-decoration: underline;
}

.indi-login-go-back-link.indi-login-reset-wrapper {
    width: 100%;
    cursor: default;
    text-decoration: none;
}

.indi-login-remember-wrapper {
    display: flex;
    height: 16px;
}

.indi-login-form-input-wrapper p i {
    margin-right: 2px
}


.indi-login-footer-wrapper {
    position: absolute;
    bottom: 18px;
    right: 48px;
    display: flex;
    white-space: nowrap;
    height: 16px;
}

.indi-login-footer {
    font-weight: 700;
    font-size: 10px;
    display: flex;
}

.indi-login-footer-msg-1 {
    color: darkblue;
}

.indi-login-footer-msg-2 {
    color: #0707d6;
    margin-left: 4px;
}


.indi-login-form-btn-wrapper {
    margin-top: 15px;
}

.indi-login-form-btn-wrapper:active {
    border: 0;
}

.indi-login-form-btn-wrapper .indi-login-form-btn {
    height: 38px;
    width: 100%;
    border: none;
    outline: 0;
    background-color: #ef820f;
    border-radius: 4px;
    transition: all 0.5s;
    cursor: pointer;
    font-size: 13px;
    color: #fff;
}

.indi-login-form-btn-wrapper .indi-login-form-btn:hover {
    background-color: #f0650f;
}

.indi-login-form-btn-wrapper .indi-login-form-btn:focus,
.indi-login-form-btn-wrapper .indi-login-form-btn:focus-visible,
.indi-login-form-btn-wrapper .indi-login-form-btn:focus-within,
.indi-login-form-btn-wrapper .indi-login-form-btn:target,
.indi-login-form-btn-wrapper .indi-login-form-btn:visited,
.indi-login-form-btn-wrapper .indi-login-form-btn:active {
    background-color: #f0650fdb;
}

.indi-login-form-input-warning {
    border: 1px solid red !important
}

.indi-login-logo-text {
    position: relative;
    color: #fff;
    display: flex;
    text-align: center;
    justify-content: center;
    max-width: 70%;
    font-size: 40px;
    font-weight: 700;
}

.indi-login-logo-text-wrapper {
    width: 74%;
    position: relative;
    margin: 0 auto;
}


.indi-login-global-error {
    border: 1px solid red;
    margin-top: 15px;
    padding-left: 10px;
    border-left: 5px solid red;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    background-color: #f8d7da;
    display: flex;
    position: relative;
    justify-content: left;
    /* height: 29px; */
    height: auto;
}


@media (max-width:864px) {
    .container .card,
    .container .card .indi-login-page-right-side {
        min-width: 100%;
    }

    .container .card .indi-login-page-left-side {
        display: none
    }
}


.indi-app .indi-add-form-wrapper.indi-login-reset-form-wrapper {
    min-height: auto;
}


.indi-app .indi-login-reset-form-error {
    color: red;
    min-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,mCAAmC;IACnC,sEAAsE;;IAEtE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;AACJ;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;IAMI,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI;;QAEI,eAAe;IACnB;;IAEA;QACI;IACJ;AACJ;;;AAGA;IACI,gBAAgB;AACpB;;;AAGA;IACI,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".indi-login-page-left-side img {\n    object-fit: fill;\n    position: absolute;\n    /* width: 50% !important; */\n}\n\n.container .card .indi-login-page-right-side {\n    padding: 20px;\n}\n\n.indi-login-page-right-top-logo {\n    height: 100px;\n    padding-right: 20px;\n}\n\n.indi-login-page-right-top-logo img {\n    height: 75px;\n    width: 135px;\n    float: right;\n    position: relative;\n}\n\n.indi-login-page-right-top-logo p {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.indi-login-page-right-top-logo p a {\n    margin-left: 3px;\n}\n\n.indi-login-form-headings {\n    margin-top: 40px;\n    color: #2f4694;\n    font-weight: 600;\n}\n\n.indi-login-form-text-login {\n    font-size: 25px;\n}\n\n.indi-login-form-text-desc {\n    margin-top: 30px;\n    font-weight: 600;\n}\n\n.indi-login-form-wrapper {\n    /* background-color: lightgrey; */\n    /* padding: 0 110px; */\n    /* margin: 0 110px; */\n    margin: 0 30%;\n    /* border: 1px dotted lightgrey; */\n}\n\n.indi-login-form-input {\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    box-shadow: inset 0 0 0 transparent;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n    height: 38px;\n    width: 100%;\n    padding: 0 10px;\n    font-size: 13px;\n    border-radius: 3px;\n    border-color: #80bdff;\n}\n\n.indi-login-form-input:focus {\n    color: #495057;\n    border-color: #86b7fe;\n    outline: 0;\n    box-shadow: 0 0 0 2px rgb(13, 110, 253, 0.25);\n}\n\n.indi-login-form-input-wrapper {\n    position: relative;\n    margin-top: 20px;\n    height: 60px;\n}\n\n.indi-login-form-input-wrapper p {\n    margin-top: 4px;\n    font-size: 12px;\n    color: #ff4500;\n    position: absolute;\n    /* display: none; */\n}\n\n.indi-login-remember-reset {\n    /* border: 1px dotted green; */\n    /* height: 16px; */\n    height: auto;\n    position: relative;\n    top: 12px;\n    font-size: 12px;\n    display: flex;\n    justify-content: flex-end;\n    align-content: center;\n    flex-direction: row;\n}\n\n.indi-login-remember-reset.indi-login-remember-reset-extra-info {\n    position: static;\n}\n\n.indi-login-remember-checkbox.form-check-input {\n    height: 16px;\n    width: 16px;\n    display: flex;\n    cursor: pointer;\n}\n\n.indi-login-remember-label {\n    margin-left: 4px;\n    display: flex;\n}\n\n.indi-login-remember-reset>div {\n    width: 50%;\n    height: 100%;\n}\n\n.indi-login-form-btn-wrapper.m-0 {\n    margin-top: 31px !important;\n}\n\n.indi-login-reset-wrapper {\n    text-align: end;\n    float: right;\n    position: relative;\n    width: 50%;\n    right: 0;\n}\n\n.indi-login-reset-wrapper:hover {\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.indi-login-go-back-link.indi-login-reset-wrapper {\n    width: 100%;\n    cursor: default;\n    text-decoration: none;\n}\n\n.indi-login-remember-wrapper {\n    display: flex;\n    height: 16px;\n}\n\n.indi-login-form-input-wrapper p i {\n    margin-right: 2px\n}\n\n\n.indi-login-footer-wrapper {\n    position: absolute;\n    bottom: 18px;\n    right: 48px;\n    display: flex;\n    white-space: nowrap;\n    height: 16px;\n}\n\n.indi-login-footer {\n    font-weight: 700;\n    font-size: 10px;\n    display: flex;\n}\n\n.indi-login-footer-msg-1 {\n    color: darkblue;\n}\n\n.indi-login-footer-msg-2 {\n    color: #0707d6;\n    margin-left: 4px;\n}\n\n\n.indi-login-form-btn-wrapper {\n    margin-top: 15px;\n}\n\n.indi-login-form-btn-wrapper:active {\n    border: 0;\n}\n\n.indi-login-form-btn-wrapper .indi-login-form-btn {\n    height: 38px;\n    width: 100%;\n    border: none;\n    outline: 0;\n    background-color: #ef820f;\n    border-radius: 4px;\n    transition: all 0.5s;\n    cursor: pointer;\n    font-size: 13px;\n    color: #fff;\n}\n\n.indi-login-form-btn-wrapper .indi-login-form-btn:hover {\n    background-color: #f0650f;\n}\n\n.indi-login-form-btn-wrapper .indi-login-form-btn:focus,\n.indi-login-form-btn-wrapper .indi-login-form-btn:focus-visible,\n.indi-login-form-btn-wrapper .indi-login-form-btn:focus-within,\n.indi-login-form-btn-wrapper .indi-login-form-btn:target,\n.indi-login-form-btn-wrapper .indi-login-form-btn:visited,\n.indi-login-form-btn-wrapper .indi-login-form-btn:active {\n    background-color: #f0650fdb;\n}\n\n.indi-login-form-input-warning {\n    border: 1px solid red !important\n}\n\n.indi-login-logo-text {\n    position: relative;\n    color: #fff;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    max-width: 70%;\n    font-size: 40px;\n    font-weight: 700;\n}\n\n.indi-login-logo-text-wrapper {\n    width: 74%;\n    position: relative;\n    margin: 0 auto;\n}\n\n\n.indi-login-global-error {\n    border: 1px solid red;\n    margin-top: 15px;\n    padding-left: 10px;\n    border-left: 5px solid red;\n    border-bottom-left-radius: 5px;\n    border-top-left-radius: 5px;\n    background-color: #f8d7da;\n    display: flex;\n    position: relative;\n    justify-content: left;\n    /* height: 29px; */\n    height: auto;\n}\n\n\n@media (max-width:864px) {\n    .container .card,\n    .container .card .indi-login-page-right-side {\n        min-width: 100%;\n    }\n\n    .container .card .indi-login-page-left-side {\n        display: none\n    }\n}\n\n\n.indi-app .indi-add-form-wrapper.indi-login-reset-form-wrapper {\n    min-height: auto;\n}\n\n\n.indi-app .indi-login-reset-form-error {\n    color: red;\n    min-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
